<template>
    <div class="col-12 col-lg-3 h-100 d-flex flex-column">
        <div class="row">
            <h3>Hello {{ user.first_name }}!</h3>
            <div class="alert alert-warning mt-3 mb-0 w-100" @click="setPage('more')" v-if="user.anonymous == '1'">You are in anonymous mode<i class="fas fa-user-secret float-right"></i></div>
        </div>

        <section class="mood-section row flex-grow-1 mt-3 ">
            <div class=" w-100 justify-content-center">
                <div class="chatBubble mb-3" v-if="emotions && mood.mood_window && mood.mood_window_id === mood.mood_window.id">You are feeling {{ emotions.find(mood => mood.id === selectedMood).name }}!</div>
                <div class="chatBubble mb-3" v-if="mood.mood_window && mood.mood_window_id !== mood.mood_window.id">How are you feeling {{ (mood.mood_window.name === 'Night' ? 'to' : 'this') }} {{ mood.mood_window.name.toLowerCase() }}?</div>
                <i v-else class="mood-submitted far fa-check-circle"></i>
                <div id="mood" class="text-center mt-0 mt-lg-5">
                    <div id="mood-touch-prevent" v-show="mood.mood_window && mood.mood_window_id === mood.mood_window.id"></div>
                    <i v-if="mood.mood_window && mood.mood_window_id !== mood.mood_window.id" @click="previousMood" class="swipe-indicator left fas fa-angle-double-left"></i>
                    <div v-if="emotions && showEmoticons" :class="emotions && showEmoticons ? 'show' : 'hide'">
                        <img id="emotion" :src="require(`@/assets/moods/${emotions.find(mood => mood.id === selectedMood).image}`)" alt class="icon bounce" @click="doubleClickCheck" draggable="false" style="touch-action: none"/>
                        <small class="text-center">
                        <span v-if="(mood.mood_window && mood.mood_window_id !== mood.mood_window.id) || mood.today === '0'" class="text-muted m-2 badge badge-light">
                          {{ isTracking ? "You're Feeling " + emotions.find(mood => mood.id === selectedMood).name : mood.today && mood.mood_window_id === 1 ? "You're Feeling " + emotions.find(mood => mood.id === selectedMood).name : userNotSelectedMood ? 'You Feel ' + emotions.find(mood => mood.id === selectedMood).name + '? Double tap to save!' : swipePromptText }}
                        </span>
                        </small>
                    </div>
                    <i v-if="mood.mood_window && mood.mood_window_id !== mood.mood_window.id" @click="nextMood" class="swipe-indicator right fas fa-angle-double-right"></i>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Mood',
    props: [
        'user'
    ],
    data() {
        return {
            moodWindowId: null,
            defaultMood: 8,
            swipePromptText: 'Swipe to change, double tap to save.',
            isTracking: false,
            selectedMood: null,
            mood: {
                mood: null
            },
            emotions: [],
            partition: [],
            winWidth: 0,
            tapedTwice: false,
            userNotSelectedMood: false,
            showEmoticons: false,
            doubleClickCount: 0
        }
    },
    methods: {
        doubleClickCheck() {
            let self = this;
            if ((self.mood.mood_window_id !== self.mood.mood_window.id) || self.mood.today === "0") {
                self.doubleClickCount++;
                setTimeout(() => {
                    self.doubleClickCount = 0;
                }, 300);

                if (self.doubleClickCount === 2) {
                    this.saveEmotion();
                    self.doubleClickCount = 0;
                }
            } else {
                self.showAlert({'message': 'You have already submitted your emotion for this period'});
            }
        },
        getMoodIcons() {
            let self = this;
            axios.get("/api/mood/icons/").then(response => {
                if (response.data) {
                    response.data.forEach(obj => {
                        const img = new Image();
                        img.src = require('@/assets/moods/' + obj.image);
                    });
                    self.emotions = response.data;
                    self.emotions.unshift({id: 1, name: "Grumpy", image: "mood1.png", score: 1})
                    self.showEmoticons = true;

                    self.resizeImage();
                }
            });
        },
        getCurrentMood() {
            let self = this;
            axios.get("/api/mood/user/" + self.user.id + "/current").then(response => {
                if (response.data) {
                    self.mood = response.data;
                    self.moodWindowId = self.mood.mood_window.id;

                    if (self.mood.mood) {
                        self.selectedMood = self.mood.mood
                    } else if (!self.mood.mood && self.$session.get('mood')) {
                        self.selectedMood = self.mood.mood = self.$session.get('mood');
                    } else {
                        self.mood.mood = self.defaultMood;
                    }

                    if (
                        (self.mood.mood_window_id !== self.mood.mood_window.id) ||
                        self.mood.today === "0" ||
                        self.mood.mood === undefined
                    ) {
                        self.selectedMood = self.mood.mood = self.defaultMood;
                    }


                    // console.log(self.$session.get('mood'))
                    // console.log(!self.$session.get('mood'))
                    // console.log(self.mood.mood)
                    // console.log(!Number.isInteger(parseInt(self.mood.mood)))
                    // console.log((self.mood.mood_window_id !== self.mood.mood_window.id))
                    //
                    // if (
                    //     !self.$session.get('mood') &&
                    //     !Number.isInteger(parseInt(self.mood.mood)) &&
                    //     (self.mood.mood_window_id !== self.mood.mood_window.id)
                    // ) {
                    //     console.log('here')
                    //     self.mood.mood = self.defaultMood;
                    // }
                    //
                    // if (
                    //     self.mood.mood &&
                    //     (
                    //         !response.data.hasOwnProperty("mood") ||
                    //         (self.mood.mood_window_id !== self.mood.mood_window.id) ||
                    //         self.mood.today === "0" ||
                    //         self.mood.mood === undefined
                    //     )
                    // ) {
                    //     console.log('here2')
                    //     self.selectedMood = self.mood.mood = response.data.mood
                    //     self.$session.set('mood', self.selectedMood);
                    // } else {
                    //     console.log('here3')
                    //     self.selectedMood = self.mood.mood = self.$session.get('mood');
                    // }

                    $('body').addClass(self.mood.mood_window.name.toLowerCase() + '-gradient');
                    self.moodSlider();
                }
            });
        },
        saveEmotion() {
            let self = this;
            if ((self.mood.mood_window_id !== self.mood.mood_window.id) || self.mood.today === "0") {
                let mood = self.mood.mood;
                let formData = new FormData();
                formData.append('mood', mood);
                formData.append('user_id', self.user.id);
                formData.append('anonymous', self.user.anonymous);
                axios.post("/api/mood/save/", formData).then(response => {
                    self.mood.mood = mood;
                    self.mood.today = 1;
                    self.mood.mood_window_id = response.data.mood_window_id;
                    self.$session.set('mood', mood);
                    $('#mood img').addClass('bounce').removeClass('shake');
                    self.showAlert({'message': 'Mood Saved!'});
                    self.getCurrentMood();

                });
            }
        },
        moodSlider() {
            let self = this;
            if ((self.mood.mood_window_id !== self.mood.mood_window.id) || self.mood.today === "0") {
                document.getElementById('mood').addEventListener('mousedown', () => {
                    self.isTracking = true;
                }, {passive: true});
                // document.getElementById('mood').addEventListener('mousemove', self.mouseTrack, {passive: true});
                document.getElementById('mood').addEventListener('mouseup', () => {
                    self.isTracking = false
                }, {passive: true});
                document.getElementById('mood').addEventListener("touchstart", () => {
                    self.isTracking = true;
                }, {passive: true});
                document.getElementById('mood').addEventListener("touchmove", self.mouseTrack, {passive: true});
                document.getElementById('mood').addEventListener("touchend", () => {
                    self.isTracking = false
                }, {passive: true});
                document.getElementById('mood').addEventListener("touchcancel", () => {
                    self.isTracking = false
                }, {passive: true});
            }
            document.getElementById('emotion').addEventListener("touchstart", (e) => {

                if (!self.tapedTwice) {
                    self.tapedTwice = true;
                    setTimeout(function () {
                        self.tapedTwice = false;
                    }, 100);
                    return false;
                }

                self.saveEmotion();
                return false;
            }, {passive: true});

        },
        resizeImage(e) {
            this.winWidth = document.getElementById('mood').clientWidth;
            let segment = Math.round(this.winWidth / this.emotions.length);

            for (let i = 0; i <= this.emotions.length; i++) {
                let newSegment = segment * i;
                this.partition.push(newSegment);
            }
        },
        mouseTrack(e) {
            let self = this;
            let clientX = 0;
            if ((self.mood.mood_window_id !== self.mood.mood_window.id) || self.mood.today === "0") {
                let marginLeft = $('#mood').offset().left;

                if (!self.isTracking) return;
                if (e.changedTouches !== undefined) {
                    clientX = e.changedTouches[0].clientX
                } else if (e.clientX) {
                    clientX = e.clientX
                }
                clientX = clientX - marginLeft;

                self.emotions.forEach(function (mood, index) {
                    if (index > 0 && mood.name && clientX > self.partition[index] && clientX < self.partition[index + 1]) {
                        self.mood.mood = index;
                        self.selectedMood = mood.id;
                    }
                })
            }
            e.stopPropagation();
        },
        nextMood: function () {
            if (this.selectedMood > 1) {
                this.selectedMood--;
                this.mood.mood = this.selectedMood;
            }
        },
        previousMood: function () {
            if (this.selectedMood < (this.emotions.length - 1)) {
                this.selectedMood++;
                this.mood.mood = this.selectedMood;
            }
        }
    },
    mounted() {
        let self = this;
    },
    created() {
        this.getMoodIcons();
        this.mood.mood = this.selectedMood = (this.$session.get('mood') && this.$session.get('mood') !== '' ? this.$session.get('mood') : this.defaultMood);
    },
    watch: {
        emotions: function () {
            if (this.user.id) {
                this.getCurrentMood();
            }
        },
        mood: function () {
            this.$parent.$data.mood = this.mood;
        },
        isTracking: function () {
            this.userNotSelectedMood = true;
            if ((this.mood.mood_window && this.mood.mood_window_id !== this.mood.mood_window.id) || this.mood.today === '0') {
                if (this.isTracking) {
                    $('#mood img').removeClass('bounce').removeClass('shake');
                } else {
                    $('#mood img').addClass('shake');
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Mood.vue